<button
  color="accent"
  mat-stroked-button
  (click)="onClick.emit()">
  @if (icon() != null) {
    <mat-icon
      [fontSet]="icon().set"
      [fontIcon]="icon().name" />
  }
  {{ label() }}
</button>
